module.exports = __webpack_public_path__ + "static/img/jienengxinfeng.7da13400.jpg";